import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal, Text, TextButton } from '@amzn/storm-ui';

import { CustomButton } from '../CustomButton';

interface ConfirmationModalProps {
  isOpen: boolean;
  title: string;
  message: ReactNode;
  onConfirmCb: () => void;
  onCancelCb: () => void;
  confirmButtonText: string;
  confirmButtonDisabled?: boolean;
  confirmButtonColor?: string;
  children?: ReactNode;
}

export const CustomConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  title,
  message,
  onConfirmCb,
  onCancelCb,
  confirmButtonText,
  confirmButtonColor,
  confirmButtonDisabled = false,
  children,
}) => {
  const { t } = useTranslation();

  const Footer = () => (
    <>
      <TextButton onClick={onCancelCb}>{t('cancel-button')}</TextButton>

      <CustomButton
        text={confirmButtonText}
        backgroundColor={confirmButtonColor}
        handleOnClickCb={onConfirmCb}
        disabled={confirmButtonDisabled}
      />
    </>
  );

  return (
    <Modal
      isOpen={isOpen}
      header={title}
      footer={<Footer />}
      onClose={onCancelCb}
    >
      <Text>{message}</Text>
      {children}
    </Modal>
  );
};
